"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSalesposter = void 0;
var create_tracking_params_1 = require("./create-tracking-params");
var enrich_salesposter_1 = require("./enrich-salesposter");
var structure_response_1 = require("./structure-response");
/**
 * Used to parse & pre-process CM salesposter responses with html
 * @param salesposterResponse json response from CM
 * @param options options adjusting or calculating the tracking parameters
 * @returns the enriched salesposter object + tracking parameters
 */
function createSalesposter(salesposterResponse, options) {
    var salesposterElem = (0, structure_response_1.structureSalesposterResponse)(salesposterResponse);
    var trackingParams = (0, create_tracking_params_1.createTrackingParams)(salesposterElem, options);
    var enrichedSalesposter = (0, enrich_salesposter_1.enrichSalesposter)({
        searchParams: trackingParams.searchParams,
        returnUrl: trackingParams.returnUrl,
        structuredResponse: salesposterElem,
    });
    return {
        salesposter: enrichedSalesposter,
        data: trackingParams.data,
        pulseOrigin: trackingParams.pulseOrigin,
    };
}
exports.createSalesposter = createSalesposter;
//# sourceMappingURL=create-salesposter.js.map